export default "__VITE_ASSET__BuT2ZOhv__"